import React from 'react'
import { Field } from 'formik'

export const Checkbox = ({
  name,
  label,
  fontSize = '14px',
  border = '1px solid #d8d8d8',
  onChange,
  boxSize = { width: '16px', height: '16px' },
  checkSize = { width: '9px', height: '5px' },
  boxPosition = { top: '16px', left: '8px' },
  checkPosition = { left: '12px', top: '20px' }
}) => {
  return (
    <>
      <Field name={name}>
        {({ field, form }) => (
          <div className='checkbox'>
            <input
              type='checkbox'
              id={name}
              checked={field.value}
              onChange={() => {
                onChange?.(!field.value)
                form.setFieldValue(name, !field.value)
              }}
            />
            <label htmlFor={name}>{label}</label>
          </div>
        )}
      </Field>
      <style jsx>{`
        .checkbox {
          margin: 10px 0;
          display: flex;
          align-items: center;
        }
        .checkbox input[type='checkbox'] {
          opacity: 0;
          margin: 0;
        }
        .checkbox label {
          position: relative;
          display: inline-block;
          padding-left: 30px;
          font-size: ${fontSize};
          font-weight: normal;
          letter-spacing: 0.1px;
          line-height: 20px;
          cursor: pointer;
          border: ${border} !important;
        }
        .checkbox input {
          display: none;
        }
        .checkbox input[type='checkbox']:checked + label::before {
          background: #007aff;
          border-color: #007aff;
        }
        .checkbox label::before,
        .checkbox label::after {
          position: absolute;
          content: '';
          display: inline-block;
        }
        .checkbox label::before {
          height: ${boxSize.height};
          width: ${boxSize.width};
          border: 1px solid #999999;
          left: ${boxPosition.left};
          top: ${boxPosition.top};
        }
        .checkbox label::after {
          height: ${checkSize.height};
          width: ${checkSize.width};
          border-left: 2px solid #fff;
          border-bottom: 2px solid #fff;
          transform: rotate(-45deg);
          left: ${checkPosition.left};
          top: ${checkPosition.top};
        }
        .checkbox input[type='checkbox'] + label::after {
          content: none;
        }
        .checkbox input[type='checkbox']:checked + label::after {
          content: '';
        }
      `}</style>
    </>
  )
}
